var GtmService = /** @class */ (function () {
    function GtmService() {
        if (!Object.hasOwnProperty.call(window, 'dataLayer')) {
            console.error('`window.dataLayer` is not defined.');
        }
    }
    GtmService.prototype.push = function (data) {
        window['dataLayer'].push({ event: data });
    };
    return GtmService;
}());
export default GtmService;
